import { ExpansionPanelSummary, Tooltip, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';
import { ContainerHead } from '../../styles';

const VinculosAutomaticosHeader = ({ title }) => {
  return (
    <ContainerHead>
      <ExpansionPanelSummary style={{ paddingLeft: 16 }} expandIcon={<ExpandMoreIcon />}>
        <Typography style={{ marginRight: 16, fontWeight: 700 }} variant="button">
          {title}
        </Typography>
        <Tooltip
          title='O sistema utiliza os vínculos dos processos com as categorias para que elas sejam identificadas, de forma automática, nos lançamentos. Por exemplo, quando uma conta a receber ou a pagar for baixada e possuir juros, o valor será lançado na classe de conta determinada para o processo "Juros".'
          placement="right"
        >
          <div className="text-32">
            <FaQuestionCircle size={15} />
          </div>
        </Tooltip>
      </ExpansionPanelSummary>
    </ContainerHead>
  );
};

export default VinculosAutomaticosHeader;
